import axios from "axios";

const BASE_URL = "https://gg-api.nationtonation.ca/api/auth";

export const fetchAdmins = async () => {
    const response = await axios.get(`${BASE_URL}/admins`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
};

export const createAdmin = async (adminData: { name: string; email: string; password: string }) => {
    const response = await axios.post(`${BASE_URL}/register`, adminData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
};

export const updateAdmin = async (
    adminId: string,
    adminData: { name: string; email: string; password?: string } // Password is optional
) => {
    const response = await axios.put(`${BASE_URL}/admins/${adminId}`, adminData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
};
export const deleteAdmin = async (adminId: string) => {
    const response = await axios.delete(`${BASE_URL}/admins/${adminId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
};
